function VueBus(Vue) {
	var bus = new Vue();

	Object.defineProperties(bus, {
		on: {
			get() {
				return this.$on;
			}
		},
		once: {
			get() {
				return this.$once;
			}
		},
		off: {
			get() {
				return this.$off;
			}
		},
		emit: {
			get() {
				return this.$emit;
			}
		}
	});

	Vue.bus = bus;

	Object.defineProperty(Vue.prototype, "$bus", {
		get() {
			return bus;
		}
	});

	Vue.mixin({
		created: function() {
			var $bus = this.$options.events;
			this.$busListeners = {};
			for (var name in $bus) {
				this.$busListeners[name] = $bus[name].bind(this); //rebind and remember each declared listener
				bus.$on(name, this.$busListeners[name]); //register a listener for the event
			}
		},
		beforeDestroy: function() {
			//unreg listeners
			for (var name in this.$busListeners) bus.$off(name, this.$busListeners[name]);
			this.$busListeners = null;
		}
	});
}

if (typeof window !== "undefined" && window.Vue) {
	window.Vue.use(VueBus);
}

export default VueBus;
